module.exports = __webpack_public_path__ + "poster12.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster12.png
// module id = 1142
// module chunks = 10